/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsBoardFinderData } from './hosports-board-finder.data';
import { IHosportsBoardFinderProps } from './hosports-board-finder.props.autogenerated';

export interface IHosportsBoardFinderViewProps extends IHosportsBoardFinderProps<IHosportsBoardFinderData> {

}

/**
 *
 * HosportsBoardFinder component
 * @extends {React.PureComponent<IHosportsBoardFinderProps<IHosportsBoardFinderData>>}
 */
class HosportsBoardFinder extends React.PureComponent<IHosportsBoardFinderProps<IHosportsBoardFinderData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default HosportsBoardFinder;
